<template>
  <div class="iframe-page-root">
    <header class="iframe-topbar">
      <button
        type="button"
        class="iframe-topbar-btn"
        @click="toolbarBack"
      >
        <i class="fas fa-chevron-left" aria-hidden="true"></i>
      </button>
      <div class="iframe-topbar-title-wrap">
        <p class="iframe-topbar-subtitle">{{ displayProviderName }}</p>
        <h1 class="iframe-topbar-title">{{ displayGameName }}</h1>
      </div>
      <button
        type="button"
        class="iframe-topbar-btn"
        @click="toolbarHome"
      >
        <i class="fas fa-home" aria-hidden="true"></i>
      </button>
      <button
        type="button"
        class="iframe-topbar-btn iframe-topbar-btn--deposit"
        @click="toolbarDeposit"
      >
        <i class="fas fa-wallet" aria-hidden="true"></i>
      </button>
    </header>

    <iframe
      name="iframe1"
      :srcdoc="isHttp ? null : $store.state.iframeURL"
      :src="isHttp ? $store.state.iframeURL : null"
      class="iframe-embed bg-dark"
      title="game"
    />

  </div>
</template>
<script>
import { deriveIframeGameTitle } from '@/libs/openGameInIframe';

export default {
  async mounted() {
    if (!this.$store.state.iframeURL) {
      this.$router.push('/home');
    }
  },
  computed: {
    // http(s) and blob: (HTML converted to blob URL, e.g. PGSoft) use src;
    // raw HTML from other callers still uses srcdoc
    isHttp() {
      const u = this.$store.state.iframeURL || '';
      return typeof u === 'string' && (u.startsWith('http') || u.startsWith('blob:'));
    },
    displayProviderName() {
      return this.$store.state.iframeProviderName || this.$t('iframe.home');
    },
    displayGameName() {
      return this.$store.state.iframeGameName || this.$store.state.iframeGameTitle || this.$t('iframe.playing');
    },
  },
  watch: {
    '$store.state.language'() {
      const u = this.$store.state.iframeURL;
      if (!u) return;
      if (this.$store.state.iframeGameName) return;
      const lang = this.$store.state.language || 'en';
      this.$store.commit('setIframeGameTitle', deriveIframeGameTitle(u, lang));
    },
  },
  beforeRouteLeave(to, from, next) {
    if (to.path === '/deposit') {
      next();
      return;
    }
    this.$store.commit('clearIframePlaySession');
    next();
  },
  methods: {
    toolbarHome() {
      this.$store.commit('clearIframePlaySession');
      this.$router.push('/home').catch(() => {});
    },
    toolbarBack() {
      if (window.history.length > 1) {
        this.$store.commit('clearIframePlaySession');
        this.$router.go(-1);
      } else {
        this.toolbarHome();
      }
    },
    toolbarDeposit() {
      this.$router.push('/deposit').catch(() => {});
    },
  },
};
</script>
<style scoped>
.iframe-page-root {
  position: relative;
  width: 100%;
  flex: 1 1 auto;
  min-height: 0;
  display: flex;
  flex-direction: column;
  background: #2d0708;
}

.iframe-topbar {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 10px 8px;
  background: linear-gradient(180deg, #791716 0%, #5a1114 100%);
  border-bottom: 1px solid rgba(236, 210, 209, 0.35);
}

.iframe-topbar-btn {
  width: 36px;
  height: 36px;
  border: none;
  border-radius: 10px;
  color: #fff;
  background: rgba(255, 255, 255, 0.12);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 0.95rem;
}

.iframe-topbar-btn--deposit {
  background: linear-gradient(135deg, #791716 0%, #a31722 50%, #d93b45 100%);
}

.iframe-topbar-title-wrap {
  flex: 1 1 auto;
  min-width: 0;
}

.iframe-topbar-subtitle {
  margin: 0 0 2px;
  font-size: 0.66rem;
  color: rgba(255, 255, 255, 0.75);
  text-transform: uppercase;
  letter-spacing: 0.08em;
}

.iframe-topbar-title {
  margin: 0;
  font-size: 0.86rem;
  font-weight: 700;
  color: #fff;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.iframe-embed {
  flex: 1 1 auto;
  min-height: 0;
  width: 100%;
  border: none;
  z-index: 1;
  background: #04090a !important;
}
</style>
